import type { SxProps, Theme } from "@mui/material"
import { Button, Card, CardContent, Typography } from "@mui/material"

const CARD_SX = { maxWidth: 360, margin: "auto", marginTop: 2, textAlign: "center" } satisfies SxProps<Theme>
const TEXT_SX = { lineHeight: 1.7, marginBottom: 3 } satisfies SxProps<Theme>

function logout() {
  window.location.assign("/logout")
}

export default function AccountMcpOnly() {
  return <Card sx={CARD_SX} elevation={0} square>
    <CardContent>
      <Typography variant="h4" component="h1" color="primary" gutterBottom>MCP access only</Typography>
      <Typography sx={TEXT_SX} color="text.secondary">
        This account is set up for MCP access only. Connect to it from your MCP client.
      </Typography>
      <Button color="primary" variant="contained" size="large" onClick={logout}>
        Logout
      </Button>
    </CardContent>
  </Card>
}
